module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step3_Image10.70f46a03.webp";